import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { StorageDashboardClient } from '@/features/storage/dashboard/StorageDashboardClient';
import { ownerSearch } from '@/features/storage/OwnerFilter';

interface DashboardSearch {
  /** The owner chosen for all of Opslag, by its slug (owners, step 7). */
  owner?: string;
}

export const Route = createFileRoute('/_shell/storage/dashboard')({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => ({
    owner: ownerSearch(search),
  }),
  component: DashboardRoute,
});

function DashboardRoute() {
  const { owner } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onOwner = useCallback(
    (next: string | undefined) => void navigate({ search: { owner: next }, replace: true }),
    [navigate],
  );
  return <StorageDashboardClient owner={owner} onOwner={onOwner} />;
}
